import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import { formatDate } from '../tabs/Constfunctions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

export const TableComponent = ({
  view,
  rows,
  columns,
  deleteRow,
  editRow,
  onDragEnd,
  isDraggable = false,
  isNewEstimate = false,
  handleAnswerPopup
}) => {
  const assumptionType = (type) => {
    switch (type) {
      case 'ProgramType':
        return 'Feature';
      case 'AddOn':
        return 'Addons';
      default:
        return 'General';
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <TableContainer sx={{ marginTop: '20px', maxHeight: 400 }}>
        <Table stickyHeader sx={{ minWidth: '100%' }} aria-label="simple table">
          <TableHead className="detail__tr">
            <TableRow>
              {columns.map((col, idx) => {
                return (
                  <TableCell key={idx} sx={{ display: view && (columns[1] !== 'Question' || !isNewEstimate) && idx == 0 ? 'none' : 'table-cell' }}>
                    {col}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <Droppable droppableId="droppable">
            {(provided) => (
              <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                {rows.map((row, idx) => {
                  return isDraggable && !view && isNewEstimate ? (
                    <Draggable
                      key={columns[1] === 'Assumption' ? row.Assumption + row.AssumptionId : row.Question + row.QuestionId}
                      draggableId={columns[1] === 'Assumption' ? `${row.AssumptionId}` : `${row.QuestionId}`}
                      index={idx}
                    >
                      {(provided) => (
                        <TableRow ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                          <TableCell>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: 'text.secondary'
                              }}
                            >
                              {columns[1] === 'Question' && isNewEstimate && (
                                <QuestionAnswerIcon
                                  style={{ cursor: 'pointer', marginRight: '5px' }}
                                  onClick={() => handleAnswerPopup(idx)}
                                  color={row.Answer ? 'primary' : ''}
                                />
                              )}
                              <EditIcon onClick={() => editRow(idx)} style={{ cursor: 'pointer' }} />
                              <DeleteIcon
                                onClick={() => deleteRow(columns[1] === 'Assumption' ? row.AssumptionId : row.QuestionId)}
                                style={{ cursor: 'pointer' }}
                              />
                            </Box>
                          </TableCell>

                          <TableCell>{columns[1] === 'Assumption' ? row.Assumption : row.Question}</TableCell>
                          {columns[1] === 'Assumption' && isNewEstimate && <TableCell>{assumptionType(row.AssumptionType)}</TableCell>}
                          <TableCell>{columns[1] === 'Assumption' ? row.UpdatedBy : row.AddedBy}</TableCell>
                          <TableCell>{columns[1] === 'Assumption' ? formatDate(row.Updated) : formatDate(row.Added)}</TableCell>
                        </TableRow>
                      )}
                    </Draggable>
                  ) : (
                    <TableRow key={columns[1] === 'Assumption' ? row.Assumption + row.AssumptionId : row.Question + row.QuestionId}>
                      {columns[1] === 'Question' && isNewEstimate && (
                        <TableCell>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              color: 'text.secondary'
                            }}
                          >
                            <QuestionAnswerIcon style={{ cursor: 'pointer', marginRight: '5px' }} onClick={() => handleAnswerPopup(idx)} />
                          </Box>
                        </TableCell>
                      )}
                      <TableCell>{columns[1] === 'Assumption' ? row.Assumption : row.Question}</TableCell>
                      {columns[1] === 'Assumption' && isNewEstimate && <TableCell>{assumptionType(row.AssumptionType)}</TableCell>}
                      <TableCell>{columns[1] === 'Assumption' ? row.UpdatedBy : row.AddedBy}</TableCell>
                      <TableCell>{columns[1] === 'Assumption' ? formatDate(row.Updated) : formatDate(row.Added)}</TableCell>
                    </TableRow>
                  );
                })}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </Table>
      </TableContainer>
    </DragDropContext>
  );
};
